export const RESET_CHANNELS = "RESET_CHANNELS";
export const RESET_CHANNEL = "RESET_CHANNEL";
export const RESET_ERROR = "CHANNELS_RESET_ERROR";

export const GET_CHANNELS = "GET_CHANNELS";
export const SET_CHANNELS = "SET_CHANNELS";

export const API_ERROR = "CHANNELS_API_ERROR";

export const GET_CHANNEL = "GET_CHANNEL";
export const SET_CHANNEL = "SET_CHANNEL";

export const EDIT_CHANNEL = "EDIT_CHANNEL";
export const EDIT_CHANNEL_SUCCESS = "EDIT_CHANNEL_SUCCESS";

export const CREATE_CHANNEL = "CREATE_CHANNEL";
export const CREATE_CHANNEL_SUCCESS = "CREATE_CHANNEL_SUCCESS";

export const DELETE_CHANNEL = "DELETE_CHANNEL";
export const DELETE_CHANNEL_SUCCESS = "DELETE_CHANNEL_SUCCESS";
